module.exports = __webpack_public_path__ + "img/sample2-voronoi-high.2c5270c7.png";